import {
    ExtendedAccountColumns,
    ExtendedAccountData,
    ExtendedAddress,
} from '@/backend/features/contact-management/entities/extended-account/types';
import { AccountProfileHeader, AccountProfileHeaderProps } from '@juvare/contact-management/ui/features/accounts';
import { PersonSubtitle } from '@juvare/credentialing/ui/features/person-credentials';
import { GetResponse } from '@juvare/platform-shared/features/storage';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdditionAccountHeaderContent } from './components';

export const RmsAccountProfileHeader: React.FC<AccountProfileHeaderProps> = (props) => {
    const { t } = useTranslation();
    const extendedAccount = props.account as GetResponse<ExtendedAccountData, ExtendedAccountColumns>;
    const address = props.account.data.address as ExtendedAddress;

    return (
        <AccountProfileHeader
            {...props}
            headerSubTitle={<PersonSubtitle tribeId={address?.tribeId} county={address?.county} residenceType={address?.residenceType} />}
            additionalHeaderContent={<AdditionAccountHeaderContent account={extendedAccount.data} />}
            completionBarTitle={t('common.profileCompletion')}
        />
    );
};
